import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { PropType, ref, computed } from 'vue'
import dayjs, { Dayjs } from 'dayjs'
import { useI18n } from 'vue-i18n'

const __default__ = { name: 'CosRangePickerMonth' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  startTime: {
    type: String as PropType<string>
  },
  endTime: {
    type: String as PropType<string>
  },
  format: {
    type: String as PropType<string>,
    default: 'YYYY-MM'
  },
  valueFormat: {
    type: String as PropType<string>,
    default: 'YYYY/MM/DD HH:mm:ss'
  },
  placeholder: {
    type: String as PropType<string>
  },
  allowClear: {
    type: Boolean as PropType<boolean>,
    default: true
  }
},
  emits: ['update:startTime', 'update:endTime', 'change'],
  setup(__props, { emit: __emit }) {

const { t } = useI18n()

const props = __props
const dateValue = ref<string | Dayjs>()
const emit = __emit

const modelValue = computed({
  get() {
    return dateValue.value || props.startTime || props.endTime
  },
  set(val) {
    dateValue.value = val ?? undefined
    const startTimeValue = val ? dayjs(val).startOf('month').format(props.valueFormat) : undefined
    const endTimeValue = val ? dayjs(val).endOf('month').format(props.valueFormat) : undefined
    emit('update:startTime', startTimeValue)
    emit('update:endTime', endTimeValue)
  }
})
const handleChange = (value: string | Dayjs) => {
  modelValue.value = value
  emit('change', value)
}

return (_ctx: any,_cache: any) => {
  const _component_a_date_picker = _resolveComponent("a-date-picker")!

  return (_openBlock(), _createBlock(_component_a_date_picker, {
    value: modelValue.value,
    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((modelValue).value = $event)),
    picker: "month",
    format: props.format,
    valueFormat: __props.valueFormat,
    allowClear: props.allowClear,
    placeholder: __props.placeholder || _unref(t)('common.pleaseSelect'),
    onChange: handleChange
  }, null, 8, ["value", "format", "valueFormat", "allowClear", "placeholder"]))
}
}

})